import Tippy from '@tippyjs/react';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as ActionImg } from '../../assets/actionIcon.svg';
import style from './employeesGrid.module.css';

interface PopupCellRendererProps {
  data: {
    actions: {
      employeeId?: string;
    };
  };
}

/* eslint-disable react/prop-types */
const PopupCellRenderer: React.FC<PopupCellRendererProps> = ({
  data,
}) => {
  const tippyRef = useRef<Element>(null);
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const history = useHistory();
  const hide = () => setVisible(false);
  // console.log('GRID data: ', data);

  const openLinkHandler = (option: string) => {
    hide();
    const empId = data.actions.employeeId;
    // console.log(`EMP ID: ${empId}`);
    if (option === 'edit') {
      history.push(`../popup/edit-employee/${empId}`);
    }
    if (option === 'delete') {
      history.push(`../popup/delete-employee/${empId}`);
    }
  };

  const dropDownContent = (
    <div className={style.menuContainer} role="menu">
      <div
        onClick={() => openLinkHandler('edit')}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            openLinkHandler('edit');
          }
        }}
        role="menuitem"
        tabIndex={0} // Add tabIndex to make it focusable
        className={style.menuItem}
      >
        <span className={style.itemText}>View/Edit</span>
      </div>
      <div
        onClick={() => openLinkHandler('delete')}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            openLinkHandler('delete');
          }
        }}
        role="menuitem"
        tabIndex={0} // Add tabIndex to make it focusable
        className={style.menuItem}
      >
        <span className={style.itemText}>Delete</span>
      </div>
    </div>
  );

  return (
    <Tippy
      ref={tippyRef}
      content={dropDownContent}
      visible={visible}
      onClickOutside={hide}
      allowHTML
      arrow={false}
      appendTo={document.body}
      interactive
      placement="right"
    >
      <div className={style.actionBox}>
        <button className={style.actionBtn} onClick={visible ? hide : show}>
          <p>Actions</p>
          <ActionImg />
        </button>
      </div>
    </Tippy>
  );
};

export default PopupCellRenderer;
